export const MAP_COLORS = ['#DBE9ED', '#D3D8D9'];

export const MARKER_SIZE = {
	min: 10,
	max: 25,
};

export const MAX_ZOOM_LEVEL = 8;
export const ZOOM_FACTOR = 4;
